import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserRoleService, UserRole } from '../services/user-role/user-role.service';

@Directive({
  selector: '[roleAccess]'
})
export class RoleAccessDirective implements OnInit {
  @Input('roleAccess') allowedRoles: UserRole[] = [];
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userRoleService: UserRoleService
  ) {}

  ngOnInit(): void {
    this.userRoleService.userRole$.subscribe(role => {
      this.updateView(role);
    });
  }

  private updateView(role: UserRole | null): void {
    // If no role is required or user has one of the required roles
    const hasAccess = 
      this.allowedRoles.length === 0 || 
      (role !== null && this.allowedRoles.includes(role));

    if (hasAccess && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasAccess && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
